module.exports = __webpack_public_path__ + "static/media/img-d2e92a00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/weber-logo.png
// module id = 5306
// module chunks = 39